import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { I18nText } from '@welldev-group/react-comp-lib';
import Link from '@welldev-group/rcl-link';
import ShowMore from '../ShowMore';
import RecordWireTransferModal from './RecordWireTransferModal';
import InvoicePDF from './InvoicePDF';

const InvoicesTableRowShowMore = ({ invoice, canRecordWireTransfer }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const options = [
    {
      link: invoice.showDetailsUrl,
      label: <I18nText id="billing.transactions.list.label.view_detail" />,
    },
  ];

  if (canRecordWireTransfer) {
    options.push({
      key: 'record-payment',
      item: (
        /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
        <Link
          className="show-more__content"
          modifier="default"
          onClick={() => setIsModalVisible(true)}
        >
          <I18nText id="billing.record_wire_transfer.confirm_payment" />
        </Link>
      ),
    });
  }

  if (invoice.id) {
    options.push({
      key: 'invoice-pdf',
      item: <InvoicePDF invoiceId={invoice.id} />,
    });
  }

  return (
    <>
      <RecordWireTransferModal
        invoice={invoice}
        onModalClose={() => setIsModalVisible(false)}
        isModalVisible={isModalVisible}
      />
      <ShowMore options={options} closePopover={isModalVisible} />
    </>
  );
};

InvoicesTableRowShowMore.defaultProps = {
  canRecordWireTransfer: false,
};

InvoicesTableRowShowMore.propTypes = {
  invoice: PropTypes.shape({
    showDetailsUrl: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
  canRecordWireTransfer: PropTypes.bool,
};

export default InvoicesTableRowShowMore;
